import { render, staticRenderFns } from "./CursorFollow.vue?vue&type=template&id=16149c1a&"
import script from "./CursorFollow.vue?vue&type=script&lang=js&"
export * from "./CursorFollow.vue?vue&type=script&lang=js&"
import style0 from "./CursorFollow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports